import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import styles from './LoginLayoutHeader.styles.m.css';

interface ILoginLayoutHeaderProps {
  className?: string;
}

export const LoginLayoutHeader: FC<PropsWithChildren<ILoginLayoutHeaderProps>> = (props) => {
  const { children, className } = props;
  const containerClassName = classNames(styles.container, className);

  return <h1 className={containerClassName}>{children}</h1>;
};
